import { API_METHODS, API_URL, MAX_API_TIMEOUT } from "../constants/api.constants";
import { kf1AuthenticatedHttpClient} from "kfone-frontend-core";
import { AppEnvVariables } from "../constants/environment.constants";
export enum ReportStatus {
  NOT_STARTED = "NOT_STARTED",
  SUBMITTED = "GENERATING",
  COMPLETED = "READY",
  FAILED = "QUERY_EXECUTION_FAILED",
  NO_DATA = "NO_DATA_FOUND",
  EXCEL_FAILED = "EXCEL_FAILED_TO_GENERATE"
}

const getMyQueries = async (payload: any = {}, isBgCall = false) => {
  const configUrl = `${AppEnvVariables.API_DOMAIN}${API_URL.MY_QUERIES}`; //reportname=REWARD_BENCHMARK
  const config: any = {
    method: API_METHODS.GET,
    url: configUrl
  };
  const res = await kf1AuthenticatedHttpClient(config); //isBgCall
  return res.data;
};

const getQueryDetails = async (reportId: any = {}, bgCall: boolean = false) => {
  const configUrl =
    `${AppEnvVariables.API_DOMAIN}${API_URL.MY_QUERY_DETAILS}?reportId=` +
    reportId;
  // const payloadData = {
  //   countryCode: payload?.countryCode,
  //   orgCodes: payload?.orgCodes,
  //   language: payload?.language,
  //   year: payload?.year
  // };
  const config: any = {
    method: API_METHODS.GET,
    url: configUrl
    // data: payloadData
  };
  const res = await kf1AuthenticatedHttpClient(config); //bgCall
  return res.data;
};

const downloadReport = async (reportId: any = {}, fileName: string) => {
  const configUrl =
    `${AppEnvVariables.API_DOMAIN}${API_URL.DOWNLOAD_REPORT}?reportName=REWARD_BENCHMARK&reportId=` +
    reportId;
  const headers = { "Content-Type": "blob" };
  const config: any = {
    method: API_METHODS.GET,
    url: configUrl,
    headers: headers,
    responseType: "blob",
    timeout: MAX_API_TIMEOUT,
    // data: payloadData
  };
  const res = await kf1AuthenticatedHttpClient(config);
  if (res.data) {
    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }

  return res.data;
};

export { getMyQueries, getQueryDetails, downloadReport };
